import { Injectable, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private messageService: MessageService
  ) {}

  showSuccessTranslated(messageKey: any, titleKey: any) {
    this.translateService.get([messageKey, titleKey]).subscribe(res => {
      this.showSuccess(res[messageKey], res[titleKey]);
      // this.messageService.add({ severity: 'success', summary: titleKey, detail: messageKey });
    });
  }

  showInfoTranslated(messageKey: any, titleKey: any) {
    this.translateService.get([messageKey, titleKey]).subscribe(res => {
      this.showInfo(res[messageKey], res[titleKey]);
      // this.messageService.add({ severity: 'info', summary: titleKey, detail: messageKey });
    });
  }

  showErrorTranslated(messageKey: any, titleKey: any) {
    this.translateService.get([messageKey, titleKey]).subscribe(res => {
      this.showError(res[messageKey], res[titleKey]);
      // this.messageService.add({ severity: 'error', summary: titleKey, detail: messageKey });
    });
  }

  showwarningTranslated(messageKey: any, titleKey: any) {
    this.translateService.get([messageKey, titleKey]).subscribe(res => {
      this.showwarning(res[messageKey], res[titleKey]);
      // this.messageService.add({ severity: 'warn', summary: titleKey, detail: messageKey });
    });
  }

  showSuccess(message: any, title: any) {
    this.toastrService.success(message, title);
    // this.messageService.add({ severity: 'success', summary: title, detail: message });
  }

  showInfo(message: any, title: any) {
    this.toastrService.info(message, title);
    // this.messageService.add({ severity: 'info', summary: title, detail: message });
  }

  showError(message: any, title: any) {
    this.toastrService.error(message, title);
    // this.messageService.add({ severity: 'error', summary: title, detail: message });
  }

  showwarning(message: any, title: any) {
    this.toastrService.warning(message, title);
    // this.messageService.add({ severity: 'warn', summary: title, detail: message });
  }

  clear(toastId?: number) {
    this.toastrService.clear(toastId);
  }
}
